import { apiConfig } from '../config';

/**
 * Format financial data for display in the chat
 * 
 * @param {string|Object} text - Text or object to format
 * @returns {JSX.Element} Formatted financial data as JSX
 */
export const formatFinancialData = (text) => {
  if (!text) return '';
  
  // Convert object to string if needed
  const data = typeof text === 'object' ? JSON.stringify(text) : text;
  
  return (
    <div className="financial-response">
      {data.split('\n').map((line, idx) => {
        // Handle headers marked with ###
        if (line.includes('###')) {
          return (
            <div key={idx} className="auth-header">
              {line.replace('###', '').trim()}
            </div>
          );
        }
        
        // Handle financial data lines (containing $)
        if (line.includes('$')) {
          const [label, value] = line.split(':').map(s => s.trim());
          return (
            <div key={idx} className="financial-data-row">
              <span className="label">{label}</span>
              <span className="value">{value}</span>
            </div>
          );
        }
        
        // Handle normal text lines
        if (line.trim()) {
          return (
            <div key={idx} className="info-row">
              {line.trim()}
            </div>
          );
        }
        
        // Skip empty lines
        return null;
      })}
    </div>
  );
};

/**
 * Send a chat message to the API
 * 
 * @param {string} userInput - User input text
 * @param {string} userEmail - User email 
 * @returns {Promise<Object>} API response
 */
export const sendChatMessage = async (userInput, userEmail = "admin@company.com") => {
  try {
    const response = await fetch(apiConfig.analyze, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_email: userEmail,
        query: userInput
      })
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    return await response.json();
  } catch (error) {
    console.error('Error sending chat message:', error);
    throw error;
  }
};
